module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_2.fb5540b5.png";